// noinspection HtmlUnknownTarget

import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigation } from "../../hooks/useNavigation";
import Button from "./Button";
import "./welcome.scss";
import { AuthUtils } from "../../utils/AuthUtils";
import { ROUTES } from "../../utils/navigationUtils";

// noinspection HtmlUnknownTarget
const PreLogin: React.FC = () => {
  const { t } = useTranslation();
  const { navigateTo } = useNavigation();
  const onSignInClick = async () => {
    await AuthUtils.signIn();
  };

  const onRequestQuoteClick = () => {
    navigateTo(ROUTES.CREATE_PROJECT);
  };

  const requestAQuoteButton = { backgroundColor: "#fa9b0e", hoverBackgroundColor: "#aa6b0b" };
  const signInButton = { backgroundColor: "#0057a0", hoverBackgroundColor: "#004077" };
  return (
    <>
      <section id="welcome">
        <div className="left">
          <div>
            <h1 className="fs4 fw2 text-darkblue">{t("preLogin.getStarted")}</h1>
            <div className="button-row">
              <Button onClick={onSignInClick} id="sign-in" {...signInButton}>
                {t("preLogin.signIn")}
              </Button>
              <Button
                onClick={onRequestQuoteClick}
                id="request-quote"
                {...requestAQuoteButton}
                data-testid="request-quote"
              >
                {t("preLogin.requestQuote")}
              </Button>
            </div>
            <h3 className="text-blue voffset3 fw8 fs19">{t("preLogin.challenges")}</h3>
          </div>
        </div>
        <img src="/images/welcome-mobile.jpg" alt="" className="hide-desktop voffset5" style={{ width: "100vw" }} />
        <div />
      </section>
    </>
  );
};

export default PreLogin;
